module.exports = __webpack_public_path__ + "static/media/subaru-outback-fig-1.32b005c1.jpg";